import { useParams } from "react-router";

import { useUsers, useUsersCount } from "@/common/data/useUsers";
import { useCompanyUsersTableState } from "@/company/hooks/useCompanyTableStates";

import { CompanyUsersTable } from "../components/CompanyUsersTable";

export default function CompanyUsers() {
  const { companyId } = useParams();
  const tableState = useCompanyUsersTableState();

  const { sorting, pageIndex } = tableState;
  // We only handle sorting one column for now
  const { id: sortBy, desc: sortDesc } = sorting[0] ?? {};
  const {
    data,
    isLoading,
    isFetching,
    isError: isListError,
    refetch: refetchList,
  } = useUsers({
    companyId,
    sortBy,
    sortOrder:
      sortDesc === true ? "desc" : sortDesc === false ? "asc" : undefined,
    pageIndex,
  });
  const usersCountQuery = useUsersCount(
    {
      companyId,
    },
    { enabled: !!companyId },
  );
  const totalCount = usersCountQuery.data?.totalCount ?? undefined;
  const isTableFetching = isFetching;
  const hasCountError = usersCountQuery.isError;
  const isError = isListError || usersCountQuery.isError;
  const refetch = () => {
    void refetchList();
    void usersCountQuery.refetch();
  };

  return (
    <CompanyUsersTable
      data={data}
      isError={isError}
      isFetching={isTableFetching}
      isLoading={isLoading}
      countError={hasCountError}
      totalCount={totalCount}
      onRetry={refetch}
    />
  );
}
